import * as faceapi from 'face-api.js';
import { imgUrl } from './imgUrl';

let modelsLoaded = null;
const descriptorCache = new Map();

export const loadFaceModels = () => {
  if (!modelsLoaded) {
    const base = `${process.env.PUBLIC_URL || ''}/models`;
    modelsLoaded = Promise.all([
      faceapi.nets.tinyFaceDetector.loadFromUri(base),
      faceapi.nets.faceLandmark68TinyNet.loadFromUri(base),
      faceapi.nets.faceRecognitionNet.loadFromUri(base),
    ]).catch((e) => { modelsLoaded = null; throw e; });
  }
  return modelsLoaded;
};

const detectOpts = new faceapi.TinyFaceDetectorOptions({ inputSize: 320, scoreThreshold: 0.4 });

export const getDescriptor = async (input) => {
  const result = await faceapi
    .detectSingleFace(input, detectOpts)
    .withFaceLandmarks(true)
    .withFaceDescriptor();
  return result ? result.descriptor : null;
};

const customerDescriptor = async (cust) => {
  const key = `${cust.customer_id}:${(cust.photo || '').slice(-40)}`;
  if (descriptorCache.has(key)) return descriptorCache.get(key);
  let desc = null;
  try {
    const img = await faceapi.fetchImage(imgUrl(cust.photo));
    desc = await getDescriptor(img);
  } catch (e) { desc = null; }
  descriptorCache.set(key, desc);
  return desc;
};

// Returns [{customer_id, distance, score}] sorted best-first
export const rankCustomersByFace = async (canvas, customers, limit = 3) => {
  await loadFaceModels();
  const probe = await getDescriptor(canvas);
  if (!probe) return { probeFound: false, matches: [] };
  const withPhoto = customers.filter((c) => c.photo);
  const results = [];
  for (const cust of withPhoto) {
    const desc = await customerDescriptor(cust);
    if (!desc) continue;
    const distance = faceapi.euclideanDistance(probe, desc);
    results.push({ customer_id: cust.customer_id, distance, score: Math.max(0, Math.round((1 - distance) * 100)) });
  }
  results.sort((a, b) => a.distance - b.distance);
  return { probeFound: true, matches: results.filter((r) => r.distance < 0.6).slice(0, limit) };
};
